import * as types from '@/store/types'

export default {
    state: {
        globalAlert: {
            show: false,
            message: '',
            color: ''
        },
        globalLoader: {
            show: false,
            message: '',
            color: ''
        }
    },
    getters: {
        globalAlert: state => state.globalAlert,
        globalLoader: state => state.globalLoader
    },
    mutations: {
        [types.SHOW_GLOBAL_ALERT]: (state, { value, message, color }) => {
            if (color != null) {
              state.globalAlert.color = color
            } else {
              state.globalAlert.color = 'success'
            }
            state.globalAlert.message = message
            state.globalAlert.show = value
          },
          [types.SHOW_GLOBAL_LOADER]: (state, { value, message, color }) => {
            if (color != null) {
              state.globalLoader.color = color
            } else {
              state.globalLoader.color = 'success'
            }
            state.globalLoader.message = message
            state.globalLoader.show = value
          },
          [types.EXPAND_LEFT_NAVIGATION]: (state, value) => {
            state.isExpandLeftMenu = value
          }
    }
}